<template>
  <span class="u-user-setting">
    <Icon type="md-settings" class="" />
  </span>
</template>

<script>
import "@/styles/component/user.less";
export default {
  name: "user-set"
};
</script>
